module.exports = __webpack_public_path__ + "img/map_containers.2292e5e2.svg";